@theme inline {
  --color-background-default: var(--background-default);
  --color-background-subtle: var(--background-subtle);
  --color-surface-default: var(--surface-default);
  --color-surface-raised: var(--surface-raised);
  --color-surface-sunken: var(--surface-sunken);
  --color-text-default: var(--text-default);
  --color-text-muted: var(--text-muted);
  --color-text-subtle: var(--text-subtle);
  --color-text-inverse: var(--text-inverse);
  --color-text-link: var(--text-link);
  --color-border-default: var(--border-default);
  --color-border-subtle: var(--border-subtle);
  --color-border-strong: var(--border-strong);
  --color-action-default: var(--action-default);
  --color-action-hover: var(--action-hover);
  --color-action-subtle: var(--action-subtle);
  --color-success-surface: var(--success-surface);
  --color-success-text: var(--success-text);
  --color-success-border: var(--success-border);
  --color-success-solid: var(--success-solid);
  --color-warning-surface: var(--warning-surface);
  --color-warning-text: var(--warning-text);
  --color-warning-border: var(--warning-border);
  --color-warning-solid: var(--warning-solid);
  --color-danger-surface: var(--danger-surface);
  --color-danger-text: var(--danger-text);
  --color-danger-border: var(--danger-border);
  --color-danger-solid: var(--danger-solid);
  --color-info-surface: var(--info-surface);
  --color-info-text: var(--info-text);
  --color-info-border: var(--info-border);
  --color-info-solid: var(--info-solid);
}

:root {
  --background-default: oklch(0.985104 0 0);
  --background-subtle: oklch(0.970151 0 0);
  --surface-default: oklch(1 0 0);
  --surface-raised: oklch(1 0 0);
  --surface-sunken: oklch(0.970151 0 0);
  --text-default: oklch(0.175228 0.006346 236.981786);
  --text-muted: oklch(0.426427 0.011202 232.617199);
  --text-subtle: oklch(0.645222 0.009348 225.150438);
  --text-inverse: oklch(1 0 0);
  --text-link: oklch(0.289999 0.117296 259.841938);
  --border-default: oklch(0.901624 0.003538 219.535738);
  --border-subtle: oklch(0.94007 0 0);
  --border-strong: oklch(0.645222 0.009348 225.150438);
  --action-default: oklch(0.289999 0.117296 259.841938);
  --action-hover: oklch(0.190403 0.080719 260.682766);
  --action-subtle: oklch(0.981046 0.012805 221.42319);
  --success-surface: oklch(0.97135 0.019006 140.501237);
  --success-text: oklch(0.40526 0.136911 142.712023);
  --success-border: oklch(0.775209 0.103098 142.532525);
  --success-solid: oklch(0.549041 0.184944 142.800761);
  --warning-surface: oklch(0.971893 0.01526 48.562489);
  --warning-text: oklch(0.431173 0.130695 40.89405);
  --warning-border: oklch(0.791422 0.092884 44.093664);
  --warning-solid: oklch(0.58333 0.169705 43.997259);
  --danger-surface: oklch(0.966669 0.016317 22.079707);
  --danger-text: oklch(0.374388 0.145685 19.336218);
  --danger-border: oklch(0.75077 0.106785 18.43901);
  --danger-solid: oklch(0.501996 0.192725 18.079135);
  --info-surface: oklch(0.947933 0.013249 262.378766);
  --info-text: oklch(0.331327 0.095363 262.195822);
  --info-border: oklch(0.676764 0.068234 261.470834);
  --info-solid: oklch(0.450622 0.123283 262.351496);
}
